import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
    LOYALTY_NAMESPACE,
    getters as loyaltyGetters,
} from '../../store/modules/loyalty';
import { store } from '../../store';
import { isMobileQuery } from '@gig/magic-common';

const loyaltyModule = namespace(LOYALTY_NAMESPACE);

@Component({
    name: 'loyalty-tier-card',
    store
})
export default class LoyaltyTierCard extends Vue {
    
    @loyaltyModule.Getter('level')
    loyaltyLevel!: ReturnType<typeof loyaltyGetters.level>;

    /**
     * Loyalty Card Icon
     */
    @Prop(String) icon: string | undefined;

    /**
     * Loyalty Card Title
     */
     @Prop(String) title: string | undefined;

     /**
     * Loyalty Card Subtitle
     */
    @Prop(String) subtitle: string | undefined;

    /**
     * Loyalty Card Background From - color
     */
     @Prop(String) backgroundFrom: string | undefined;

     /**
     * Loyalty Card Background To - color
     */
    @Prop(String) backgroundTo: string | undefined;

     /**
     * Loyalty Card Level
     */
    @Prop(String) level: string | undefined;

    private isMobile: boolean = false;

    async created() {
        this.isMobile = await isMobileQuery();
    }
    mounted() {
        const el = this.$el as HTMLElement;

        if (this.backgroundFrom && this.backgroundTo) {
            el.style.setProperty('--magic-card-background-from', this.backgroundFrom);
            el.style.setProperty('--magic-card-background-to', this.backgroundTo);
        }

        setTimeout(() => {
            this.scrollIntoCurrentLoyalty();
        }, 500);
    }

    scrollIntoCurrentLoyalty() {
        const el = this.$el as HTMLElement;

        if(this.loyaltyLevel === parseInt(this.level ? this.level : '', 10) && this.isMobile){
            el.scrollIntoView(false);
        }
    }
}
